import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,
  background: constants.Colors.DarkPurple,
  inputBackground: constants.Colors.White,

  ///for account landing page
  container: '#f1efe4',
  balanceInfoContainer: '#e6e3d4',
  headerPocket: '#1a1f3f',
  headerTotalAmountTitle: '#1a1f3f',
  headerCashBtn: '#005089',
  headerCashBtnLabel: '#fff',
  bottomVerifyContainer: '#fff',
  bottomVerifyMsgText: '#1a1f3f',
  bottomVerifyBtn: '#e6e3d4',
  bottomVerifyBtnBorder: '#e6e3d4',
  bottomVerifyBtnText: '#1a1f3f',
  cashbackExpiryText: '#1a1f3f',

  //for wallet bottom component
  walletBottomContainer: '#fff',
  walletBottomTitle: '#1a1f3f',
  walletBottomValue: '#1a1f3f',

  //for wallet type
  walletTypeInfoIcon: '#1a1f3f',
  walletTypeContainer: '#fff',
  walletTypeTooltipBG: '#1f2a54',
  walletTypeTitle: '#1a1f3f',
  walletTypeBalance: '#1a1f3f',
  walletTypeVerticalBorder: '#e6e3d4',
  walletTypeBtn: '#1a1f3f',

  //for withdraw modal
  withdrawContainer: '#e6e3d4',
  withdrawBackBtn: '#1a1f3f',
  withdrawVerticalDivider: '#fff',
  withdrawTitle: '#1a1f3f',
  withdrawCurrentBalance: '#1a1f3f',
  withdrawCurrentBalanceValue: '#1a1f3f',
  withdrawInputBG: '#fff',
  withdrawInputText: '#1a1f3f',
  withdrawInputPlaceHolder: '#1a1f3f',
  withdrawMinAmountLabel: '#111939',
  withdrawOptionBorder: '#434e85',
  withdrawOptionChecked: '#005089',
  withdrawOptionCheckBoxBorder: '#1a1f3f',
  withdrawPaytmTransferIcon: '#1a1f3f',
  withdrawOptionTitle: '#1a1f3f',
  withdrawButton: '#005089',
  withdrawButtonText: constants.Colors.White,
  withdrawError: '#f6324b',

  //for transaction history
  transactionHistoryContainer: constants.Colors.RegalBlue,
  transactionHistoryContainerWrapper: constants.Colors.newBackground,
  transactionHistoryTabBarDefault: '#e6e3d4',
  transactionHistoryTabBarActiveText: '#ffc600',
  transactionHistoryTabBarDefaultText: '#fff',
  transactionHistoryTabBarBorder: '#ffc600',
  transactionHistoryTabBarActive: '#ffc600',

  // add cash modal
  addCashContainer: '#e6e3d4',
  addCashBackBtn: '#1a1f3f',
  addCashVerticalDivider: '#fff',
  addCashTitle: '#1a1f3f',
  addCashCurrentBalance: '#1a1f3f',
  addCashCurrentBalanceValue: '#1a1f3f',
  addCashBoxAmountWrapper: '#f1efe4',
  addCashBoxAmountWrapperBorder: '#f1efe4',
  addCashBoxAmountText: '#1a1f3f',
  addCashPromoCodeLabel: '#1a1f3f',
  addCashAppliedPromoCode: '#11173d',
  addCashPromoCodeInputBG: '#fff',
  addCashPromoCodeInputText: '#1a1f3f',
  addCashPromoCodeInputPlaceHolder: 'rgba(255, 255, 255, 0.45)',
  addCashApplyButton: '#11173d',
  addCashApplyButtonText: constants.Colors.White,
  addCashPayUsing: '#11173d',
  addCashRemoveIcon: constants.Colors.Dusk,
  addCashBtn: '#005089',
  addCashBtnText: '#fff',
  addCashPromoListItemBG: '#fff',
  addCashPromoListItemBorder: '#26ae5f',
  addCashPromoListItemTitle: '#1a1f3f',
  addCashPromoLoader: '#1a1f3f',

  //for transaction game item
  transactionContainer: '#fff',
  transactionDateTime: '#fff',
  transactionContentText: '#f2f2f2',
  transactionExpandIconBG: '#fff',
  transactionExpandIconBorder: '#707070',
  transactionExpandIcon: '#1a1f3f',
  transactionSeparator: constants.Colors.Manatee,
  transactionDebit: '#ff4b4b',
  transactionCredit: '#00ff47',
  transactionPending: '#ffd500',
  transactionContentMainText: '#26ae5f',

  //for transaction earnings
  transactionTotalEarnings: '#fff',

  //for transfer money modal
  transferMoneyModalTitle: '#1a1f3f',
  transferMoneyModalValue: '#1a1f3f',
  transferMoneyRowBorder: constants.Colors.BlueGrey,
  transferMoneyYesBtn: constants.Colors.Green,
  transferMoneyNoBtn: constants.Colors.Pink,
  transferMoneyHeaderTitle: '#1a1f3f',
  transferMoneyAreYouSureText: '#1a1f3f',

  //for webview screen
  webviewBackground: '#fff',

  //for payment success
  paymentSuccessTitle: '#1a1f3f',
  paymentSuccessGoBack: '#26ae5f',
  paymentSuccessGoBackTitle: '#fff',
  paymentSuccessIcon: '#26ae5f',

  //for payment failed
  paymentFailTitle: '#1a1f3f',
  paymentFailGoBack: '#26ae5f',
  paymentFailGoBackTitle: '#fff',
  paymentFailedIcon: '#f00',

  //transactionhistory

  transactionHistoryDefaultCol3Bg:
    'transparent radial-gradient(closest-side at 50% 50%, #001f67 0%, #02103a 100%) 0% 0% no-repeat padding-box',
  transactionHistoryDefaultCol3BoxShadow: 'inset 0px 0px 5px #0013ff, 0px -2px 23px #020722b3',
  transactionHistoryDefaultColBg:
    ' transparent radial-gradient(closest-side at 50% 50%, #021542 0%, #000925 100%) 0% 0% no-repeat padding-box',
  transactionHistoryDefaultColBoxShadow: '0px 0px 17px #020722b3',
  transactionHistoryBorder: '#002a8b',
  transactionHistoryStatusContainerBg: '#000f3c 0% 0% no-repeat padding-box',
  transactionHistoryStatusContainerBoxShadow: '0 30px 20px 0 rgba(0, 0, 0, 0.5)',
  transactionHistoryStatusItemBg: '#FFC400 0% 0% no-repeat padding-box',
  transactionHistoryStatusItemTextColor: 'white',
  transactionHistoryActivebackdropFilter: 'blur(44px)',
  transactionHistoryActiveboxShadow: '0 10px 10px 0 rgba(0, 0, 0, 0.3)',
  transactionHistoryActivebackgroundImage: 'linear-gradient(to bottom, #f6d03f, #f8b90c)',
  transactionHistoryDefaultbackdropFilter: 'blur(44px)',
  transactionHistoryDefaultboxShadow: '0 10px 10px 0 rgba(0, 0, 0, 0.3)',
  transactionHistoryDefaultbackgroundImage: 'linear-gradient(to bottom, #000f3c, #000925)',
  transactionHistoryGameHeaderBg:
    'transparent radial-gradient(closest-side at 50% 50%, #021542 0%, #000925 100%) 0% 0% no-repeat padding-box',
  transactionHistoryGameHeaderBoxShadow: '0px 0px 17px #020722b3',
  transactionHistoryGameContentBoxShadow: 'inset 0px 0px 7px #0013ff80, 0px 0px 10px #020722b3',
  transactionHistoryGameContentBg:
    'transparent radial-gradient(closest-side at 50% 50%, #001f67 0%, #02103a 100%) 0% 0% no-repeat padding-box',
  transactionHistoryGameItemTitleBg: ' #0041c3 0% 0% no-repeat padding-box',
  transactionHistoryGameItemTitleBoxShadow: '0px 3px 6px #00000029',
  transactionHistoryGameItemValueDebitBg: '#008024',
  transactionHistoryGameItemValueDebitBorder: '#4cef33',
  transactionHistoryGameItemValueCreditBg: '#860000',
  transactionHistoryGameItemValueCreditBorder: '#008024',

  //dailyrewards

  dailyRewardsActiveItemBg:
    'transparent radial-gradient(closest-side at 50% 50%, #FFC400 0%, #FF6F00 100%) 0% 0% no-repeat padding-box',
  dailRewardsActiveItemBorder: '#ffcf00',
  dailyRewardsDefaultItemBg: 'radial-gradient(circle at center, #1b417e 10%, #001241 50%)',
  dailRewardsDefaultItemBorder: '#004dff',
  dailyRewardsCoinsBg: '#001538',
  dailyRewardsChestWrapperBg: '#00123e',
  dailyRewardsChestWrapperBorder: '#4D5968',
  dailyRewardsGameInfoContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',
  dailyRewardsGameInfoContainerBorder: '#596779',
  dailyRewardsGameInfoContainerBoxShadow: '0px -2px 23px #020722B3',
  dailyRewardsGamePlayContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #001f67 0%, #02103a 100%) 0% 0% no-repeat padding-box',
  dailyRewardsGamePlayContainerBoxShadow: 'inset 0px 0px 9px #0013ff, 0px -2px 23px #020722b3'
};
